// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1Mivq","content":"GlobalSearch_content__C2BFe"};